import { computed, ref } from 'vue';
import { getMemberPositions } from '../lib/getMemberPositions';
import { buildMemberOptions } from '../lib/buildMemberOptions';
import { useParticipantSelection } from './useParticipantSelection';

export function useTrainingSchedulingWithCollaborators() {
  const scheduledByMemberId = ref<number | null>(null);
  const scheduledByPositionId = ref<number | null>(null);

  const {
    members,
    loading,
    loaded,
    collaborators,
    unlistedMemberIds,
    visibleMemberIds,
    load,
    initializeParticipants,
  } = useParticipantSelection();

  function setScheduledByMemberId(memberId: number | null): void {
    scheduledByMemberId.value = memberId;
    const positions = getMemberPositions(members.value, memberId);
    scheduledByPositionId.value = positions.length === 1 ? positions[0]!.id : null;
  }

  const scheduledByPositions = computed(() => getMemberPositions(members.value, scheduledByMemberId.value));
  const memberOptions = computed(() => buildMemberOptions(members.value));

  return {
    scheduledByMemberId,
    scheduledByPositionId,
    members,
    loading,
    loaded,
    collaborators,
    unlistedMemberIds,
    visibleMemberIds,
    scheduledByPositions,
    memberOptions,
    load,
    setScheduledByMemberId,
    initializeParticipants,
  };
}
